(function () {
	angular
		.module('trackeye')
		.controller('ConfigurationController', ConfigurationController);

	ConfigurationController.$inject = ["$scope", "AccountService", "DeviceService", "C4ApiService", "NotificationService", "ModalService", "SunWeekParser", "$filter"];

	function ConfigurationController($scope, AccountService, DeviceService, api, NotificationService, ModalService, SunWeekParser, $filter) {
		var vm = this,
			defaults = {
				report: [21600, 43200, 86400, 172800],
				gsensor: [900, 1800, 3600, 7200, 10800]
			};

		vm.gsensor = [];
		vm.report = [];
		vm.is_loading = false;
		vm.ignore_modal = false;
		vm.settingsForm = {};
		vm.account = AccountService.get();
		vm.cyoh_week = []
		vm.cyoh_sun = []
		vm.config = {
			error: false
		};

		/**
		 * @type {Device}
		 */
		vm.device = DeviceService.getSelectedDevice();
		
		var accountConfig = vm.account.getConfiguration();
		var confirmModal = ModalService.create('confirm-settings', vm);

		var device_mock = vm.device.isMock();

		vm.hideConfiguration = function () {
			return vm.device.features.isCapture() || vm.device.features.isPower() || !DeviceService.hasSutDevices();
		}

		vm.configurationHiddenMessage = function () {
			if (!DeviceService.hasSutDevices()) {
				return "STR_NO_DEVICES";
			} else if (vm.device.features.isCapture() || vm.device.features.isPower()) {
				return "STR_CHANGING_SETTINGS_IS_DISABLED";
			}
		}

		vm.hasImmutableConfiguration = function () {
			return vm.device.features.isCapture() || vm.device.features.isPower();
		};

		vm.showBeaconConfiguration = function () {
			return (
				vm.device.features.isRapid()
			);
		};

		vm.showBeaconActivatedAt = function () {
			return (
				vm.config.act_ts &&
				vm.config.beacon === 'on'
			);
		};

		vm.showGpsConfiguration = function () {
			return (
				vm.device.features.hasGps() &&
				!vm.device.limitation.isConfDisabled('number_of_pos')
			);
		};

		vm.showRefindingConfiguration = function () {
			return vm.device.features.hasBeacon();
		};

		vm.showGSensorConfiguration = function () {
			return vm.device.features.hasGSensor();
		};

		vm.hasGSensorOptionOff = function () {
			return !vm.device.limitation.isConfDisabled('gsensor.off')
		};

		vm.showChooseYourOwnHours = function () {
			return !vm.device.limitation.isConfDisabled('choose_own_hours');
		};

		vm.isChooseYourOwnHoursSelected = function () {
			return (
				vm.config.interval === 'weeksun' &&
				!vm.device.limitation.isConfDisabled('choose_own_hours')
			);
		};

		initSutConfiguration();

		$scope.$on('DeviceService.selected', function (e, device) {
			vm.device = device;

			if (!device_mock) {
				initSutConfiguration();
			} else {
				device_mock = vm.device.isMock();
			}
		});

		function initSutConfiguration () {
			vm.gsensor = [];
			vm.report = [];

			vm.config = {
				error: false
			};

			vm.is_loading = true;
			if (vm.device.postInitialized) {
				renderReportIntervals();
				loadSutConfiguration();
			} else {
				vm.device.on('postLoad', function() {
					renderReportIntervals();
					loadSutConfiguration();
				}, 'ConfigurationController');
			}
		}

		function loadSutConfiguration () {
			DeviceService.getConfig(vm.device)
				.then(function(xhr) {
					vm.config = xhr.data;
					var week = new SunWeekParser(xhr.data.week)
					var sun = new SunWeekParser(xhr.data.sun)

					vm.cyoh_week = week.toStringArray()
					vm.cyoh_sun = sun.toStringArray()
				})
				.catch(function() { vm.config.error = true; })
				.finally(function() { vm.is_loading = false; });
		}

		function renderReportIntervals() {
			var gsensor = vm.device.limitation.filterGSensor(defaults['gsensor']),
				report = vm.device.limitation.filterReportInterval(defaults['report']);

			gsensor.sort(sortLowHigh);
			report.sort(sortLowHigh);

			vm.gsensor = renderReportObject(gsensor);
			vm.report = renderReportObject(report);

			function renderReportObject(list) {
				return list.map(function (int) {
					var tmp = {
						interval: int.toString(),
						readable: 0,
						translate: undefined
					};

					if (int == 3600) {
						tmp.translate = "STR_EVERY_HOUR";
					} else if (int > 3600) {
						tmp.translate = "STR_EVERY_NTH_HOUR";
						tmp.readable = int / 60 / 60;
					} else if (int < 3600) {
						if (int == 60) {
							tmp.translate = "STR_EVERY_MINUTE";
						} else if (int > 60) {
							tmp.translate = "STR_EVERY_NTH_MINUTE";
							tmp.readable = int / 60;
						} else if (int == 30) {
							tmp.translate = "STR_GSENSOR_FAST";
							tmp.readable = 0;
						} else {
							tmp.translate = "STR_EVERY_NTH_SECOND";
							tmp.readable = int;
						}
					}

					return tmp;
				});
			}

			function sortLowHigh(a, b) {
				if (a > b) return 1;
				if (a < b) return -1;
				return 0
			}
		}

		vm.confirmSave = function () {
			vm.ignore_modal = accountConfig.get('settings.modals.confirm_settings.ignore');
			if (!vm.ignore_modal) {
				confirmModal.open();
			} else {
				vm.saveSettings(vm.ignore_modal);
			}
		}

		// @todo guid is used, because c4api -> flexws/sutmessage is not working properly
		// should only be one call
		vm.saveSettings = function (ignore_modal) {
			if (ignore_modal !== vm.ignore_modal) {
				var modalSetting = {confirm_settings: { ignore: ignore_modal } };
				var settings = accountConfig.get('settings') || {};
				settings.modals = modalSetting;

				accountConfig.set('settings', settings);
				accountConfig.save();

				vm.ignore_modal = ignore_modal;
			}
			confirmModal.close();

			if (!vm.settingsForm.$dirty) {
				return;
			}

			var weekValue = "",
					sunValue = "";

			if (vm.config.interval == "weeksun") {
				var week = new SunWeekParser(vm.cyoh_week),
						sun = new SunWeekParser(vm.cyoh_sun)

				if (!week.hasItems() && !sun.hasItems()) {
					// CYOH is selected, but no schedule is specified
					return
				}

				weekValue = week.toString()
				sunValue = sun.toString()

				// Set the UI to the filtered and sorted data
				vm.cyoh_week = week.toStringArray()
				vm.cyoh_sun = sun.toStringArray()
			}

			vm.is_loading = true;
			api.configSet({
				guid: vm.device.guid,
				week: weekValue,
				sun: sunValue,
				interval: vm.config.interval,
				gsensor: vm.config.gsensor,
				lightsensor: vm.config.lightsensor,
				refinding: vm.config.refinding,
				beacon: vm.device.features.isRapid() ? vm.config.beacon : undefined, // this is only used, if configuring a Rapid
				gps: vm.config.gps,
				gps_revert: vm.config.gps_revert,
				lock_rmd: vm.device.features.isCapture() || vm.device.features.isRapid(),
				subscription: vm.device.getSubscription(),
				rapid: vm.device.features.isRapid()
			}).then(function (xhr) {
				if (vm.config.beacon === 'on' || vm.config.refinding != 'off')
					vm.config.act_ts = (Date.now() / 1000);

				if (xhr.NoContent()) {
					NotificationService.info("STR_NOTICE_DEVICE_CONFIG_NO_CHANGES");
				} else {
					NotificationService.info("STR_NOTICE_DEVICE_CONFIG_UPDATED");
				}
				vm.settingsForm.$setPristine();
				vm.is_loading = false
			}, function (resp) {
				//@todo forward error to backend
				console.error(resp);
				NotificationService.warning("STR_ERROR_NOTICE_SERVER");
				vm.is_loading = false;
			});
		};

		vm.checkToggle = function (name, value, offValue) {
			if (vm.config[name] === value) {
				if (angular.isDefined(offValue)) {
					vm.config[name] = offValue;
				} else {
					vm.config[name] = null;
				}
			} else {
				vm.config[name] = value;
			}
			vm.settingsForm[name].$setDirty();
		};

		vm.getActTs = function (filter) {
			var ts = vm.config.act_ts * 1000;
			if (filter) {
				return $filter('date')(ts, 'medium');
			} else {
				return vm.config.act_ts ? ts : null;
			}

		};

		function isFormItemDirty(item) {
			return (vm.settingsForm[item] && vm.settingsForm[item].$dirty);
		}
	}
})();